import React from "react";
import { useRouter } from "next/router";

import Link from "../Link";
import { ROUTE_PREFIX } from "../../constants";
import { useIntendedPath } from "../../hooks";

export default function RedirectToLoginLink({
  children,
  queryParams,
  ...delegated
}) {
  const router = useRouter();
  const { intendedPath } = useIntendedPath();

  const currentIntendedPath = intendedPath || router.asPath;

  return (
    <Link
      to={`/${ROUTE_PREFIX.LOGIN}`}
      queryParams={{
        intended_path: currentIntendedPath,
        ...queryParams,
      }}
      {...delegated}
    >
      {children}
    </Link>
  );
}
